var render = function render(){var _vm=this,_c=_vm._self._c;return _c('video',{ref:"refQRCapture",style:('max-width: ' + _vm.width + 'px;'),attrs:{"value":_vm.value,"width":_vm.width,"height":_vm.height}})
}
var staticRenderFns = []

export { render, staticRenderFns }